import { Accordion } from "../global";
import { initSection } from "../utils";

function initFaqAccordions() {
  if (document.body.dataset.suffix !== "faq-new") return;
  initSection("accordion-group", Accordion);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFaqAccordions, false);
} else {
  initFaqAccordions();
}
